import { render, staticRenderFns } from "./onpageRegistration.vue?vue&type=template&id=420d9987&"
import script from "./onpageRegistration.vue?vue&type=script&lang=js&"
export * from "./onpageRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports